// Small formatting helpers used by the panellist pages.

export function formatMoney(amount: number, currency: string, locale = 'en-GB'): string {
  try {
    return new Intl.NumberFormat(locale, {
      style: 'currency',
      currency,
      maximumFractionDigits: 2,
    }).format(amount)
  } catch {
    return `${currency} ${amount.toFixed(2)}`
  }
}

export function formatDateTime(iso: string | null, locale = 'en-GB'): string {
  if (!iso) return '—'
  try {
    return new Intl.DateTimeFormat(locale, {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      timeZoneName: 'short',
    }).format(new Date(iso))
  } catch {
    return iso
  }
}

export function maskIban(iban: string): string {
  const clean = iban.replace(/\s+/g, '')
  if (clean.length < 8) return clean
  return clean.slice(0, 4) + ' •••• •••• ' + clean.slice(-4)
}

export function maskWallet(addr: string): string {
  if (addr.length < 10) return addr
  return addr.slice(0, 6) + '...' + addr.slice(-4)
}

// Client-side IBAN mod-97 sanity. Identical algorithm to Edge Function.
export function isLikelyIban(input: string): boolean {
  const clean = input.replace(/\s+/g, '').toUpperCase()
  if (!/^[A-Z]{2}[0-9]{2}[A-Z0-9]{11,30}$/.test(clean)) return false
  if (clean.length < 15 || clean.length > 34) return false
  const rearranged = clean.slice(4) + clean.slice(0, 4)
  let numeric = ''
  for (const ch of rearranged) {
    const code = ch.charCodeAt(0)
    if (code >= 48 && code <= 57) numeric += ch
    else if (code >= 65 && code <= 90) numeric += String(code - 55)
    else return false
  }
  let remainder = 0
  for (let i = 0; i < numeric.length; i += 7) {
    const chunk = String(remainder) + numeric.slice(i, i + 7)
    remainder = Number(chunk) % 97
    if (Number.isNaN(remainder)) return false
  }
  return remainder === 1
}

export function isLikelyEvm(input: string): boolean {
  return /^0x[a-fA-F0-9]{40}$/.test(input.trim())
}
